export const REQUEST_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
};

export const UPGRADE_TYPES = {
  PLAN: 'plan',
  ROLE: 'role',
};
